import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class UserPreferenceService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.USER_PREFERENCE = '/api/userpreference';

        this.GET_BY_ID = '/{id}';
    }
    
    /**
     * This class manages the REST Protocols for User Preference.
     *
     * GET Requests:
     *     1) getUserById - GET By ID
     *
     * POST Requests:
     *     1) updateUserPreference - UPDATE User Preference
     */

    async getUserPreferenceById(id) {
        try {
            let url = window.location.origin + this.USER_PREFERENCE + this.GET_BY_ID;
            url = url
                .replace('{id}', id);
            const userRetData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userRetData;
        } catch(err) {
            console.log(err);
        }
    }

    async updateUserPreference(userData){
        try{
            let data = {
                ...userData,
                email: typeof userData.email !== 'string' ? JSON.stringify(userData.email) : userData.email,
                preferences: typeof userData.preferences !== 'string' ? JSON.stringify(userData.preferences) : userData.preferences,
                whatsapp: typeof userData.whatsapp !== 'string' ? JSON.stringify(userData.whatsapp) : userData.whatsapp,
            }
            let url = window.location.origin + this.USER_PREFERENCE;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const userPreferenceUpdated = this.fetch(url,{
                method:'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(data)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return userPreferenceUpdated;
        }
        catch(err){
            console.log(err);
        }
    }
}

export default UserPreferenceService;
